import { yupResolver } from "@hookform/resolvers/yup";
import Alert from "@mui/material/Alert";
import Autocomplete from "@mui/material/Autocomplete";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Checkbox from "@mui/material/Checkbox";
import FormControl from "@mui/material/FormControl";
import FormControlLabel from "@mui/material/FormControlLabel";
import Grid from "@mui/material/Grid";
import IconButton from "@mui/material/IconButton";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import Stack from "@mui/material/Stack";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import format from "date-fns/format";
import { useCallback, useEffect, useState } from "react";
import { prenotaStore } from "../prenotaStore";
import { uiStore } from "../uiStore";
import * as yup from "yup";
import { Controller, useFieldArray, useForm } from "react-hook-form";
import axios, { AxiosError } from "axios";
import { API_URL } from "../consts";
import { useQuery } from "react-query";
import { Loading } from "../ui/Loading";
import {
  Cards,
  Clubs,
  RisorseInfoCorrenti,
  Tariffe_Costo,
  Tipologia_Associazioni,
  Tipologia_Uso,
} from "../prismaTypes";
import DeleteIcon from "@mui/icons-material/Delete";
import { EuroFormatter } from "../utils/EuroFormatter";
import { getNumber } from "../utils/getNumber";
import { queryClient } from "../App";
import { useMutation } from "react-query";
import { useSnackbar } from "notistack";
import { changeDatesToUTC } from "../utils/dateUtils";
import { useNavigate } from "react-router-dom";
import { oraPrenotaStore } from "../oraPrenotaStore";
import { ConfermaBox } from "./ConfermaBox";
import { CardsData } from "./CardsData";
import { RigaSocio } from "./RigaSocio";
import { IsSelectable } from "./IsSelectable";

type Inputs = {
  membersId: number | null;
  tipologia_UsoId: number | string;
  idsPartecipanti: { idPartecipante: number | string }[];
  luci: boolean;
  riscaldamento: boolean;
  note: string | null;
};

type CreatePrenotazioniDto = {
  dataInizioPrenotazione: Date;
  dataFinePrenotazione: Date;
  tariffaId: number;
  membersId: number;
  tipologia_UsoId: number;
  idsPartecipanti: { idPartecipante: number }[];
  luci: boolean;
  riscaldamento: boolean;
  risorseId: number;
  cifraAddebitata: number;
  totalePerFacilities: number;
  totalePerGiocatori: number;
  slotPrenotati: number;
  risorsaInfoId: number;
  slots: { idTariffa: number }[];
  note: string | null;
};

const schema = yup
  .object({
    membersId: yup.number().typeError("Seleziona il nominativo dall'elenco!"),
  })
  .required();

export function Prenotazione() {
  const setTitle = uiStore((state) => state.setTitle);
  const { enqueueSnackbar } = useSnackbar();
  const navigate = useNavigate();

  const cambiaPrenot = () => {
    navigate("/app/tabelloneTariffe/prenota");
  };

  const { isLoading: loadingClub, data: club } = useQuery<{ club: Clubs }, AxiosError>(
    ["club/getByDomain"],
    () => axios.get(API_URL + "club/getByDomain").then((res) => res.data),
    {
      refetchOnMount: false,
      refetchOnWindowFocus: false,
    }
  );

  useEffect(() => {
    setTitle("Prenotazione");
  }, [setTitle]);

  const role = oraPrenotaStore((state) => state.role);

  const [min, setMin] = useState(0);
  const [max, setMax] = useState(0);
  const [costoSoci, setCostoSoci] = useState(0);
  const [costoLuci, setCostoLuci] = useState(0);
  const [costoRiscaldamento, setCostoRiscaldamento] = useState(0);
  const [luceIncluso, setLuceIncluso] = useState(false);
  const [riscaldamentoIncluso, setRiscaldamentoIncluso] = useState(false);
  const [modConferma, setModConferma] = useState(false);

  const giorno = prenotaStore((state) => state.giorno);
  const orario = prenotaStore((state) => state.orario);
  const risorsa = prenotaStore((state) => state.risorsa);
  const slotTariffe = prenotaStore((state) => state.slotTariffe);

  const risorsaId = risorsa?.id ?? -1;

  const { isLoading, data: membri } = useQuery<{ cards: CardsData[] }, AxiosError>(
    ["cards/findAllPrenota"],
    () => axios.get(API_URL + "cards/findAllPrenota").then((res) => res.data),
    { refetchOnWindowFocus: false }
  );

  const { isLoading: isLoading6, data: card } = useQuery<{ cards: Cards[] }, AxiosError>(
    ["cards/findMyCard"],
    () => axios.get(API_URL + "cards/findMyCard").then((res) => res.data),
    {
      refetchOnWindowFocus: false,
      enabled: role === "USER",
    }
  );

  const { isLoading: isLoading2, data: tipologieData } = useQuery<
    { tipologieUso: Tipologia_Uso[] },
    AxiosError
  >(
    ["tipologie-uso/findAll"],
    () => axios.get(API_URL + "tipologie-uso/findAll").then((res) => res.data),
    {
      refetchOnMount: role !== "USER",
      refetchOnWindowFocus: role !== "USER",
      refetchInterval: 3600 * 1000,
    }
  );

  const { isLoading: isLoading3, data: costi } = useQuery<{ tariffe: Tariffe_Costo[] }, AxiosError>(
    ["tariffe-costo/findAll/"],
    () => axios.get(API_URL + "tariffe-costo/findAll/").then((res) => res.data),
    { refetchOnMount: false }
  );

  const { isLoading: isLoading4, data: risorsaInfo } = useQuery<
    { risorseInfo: RisorseInfoCorrenti[] },
    AxiosError
  >(
    ["risorse-info", risorsaId],
    () =>
      axios.get(API_URL + "risorse-info/getRisorseInfoActive/" + risorsaId).then((res) => res.data),
    {
      refetchOnMount: false,
      enabled: risorsaId !== -1,
    }
  );

  const { isLoading: isLoading5, data: tipologieAssoc } = useQuery<
    { tipologie: Tipologia_Associazioni[] },
    AxiosError
  >(
    ["tipologie-associazioni"],
    () => axios.get(API_URL + "tipologie-associazioni/findAll").then((res) => res.data),
    { refetchOnMount: false }
  );

  const { mutate: prenota } = useMutation(
    (data: CreatePrenotazioniDto) => {
      return axios.post(API_URL + "prenotazioni/create", data);
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries();
        enqueueSnackbar("Prenotazione Effettuata", {
          variant: "success",
        });
        navigate("/app/tabelloneTariffe/prenota");
      },
      onError: (err: AxiosError) => {
        queryClient.invalidateQueries();
        enqueueSnackbar(err?.response?.data?.message ?? "Si è verificato un errore!", {
          variant: "error",
        });
      },
    }
  );

  const [tipologie, setTipologie] = useState<Tipologia_Uso[]>([]);

  const {
    control,
    handleSubmit,
    setValue,
    getValues,
    formState: { errors },
  } = useForm<Inputs>({
    mode: "all",
    resolver: yupResolver(schema),
  });
  const { fields, append, remove, update } = useFieldArray<Inputs>({
    control,
    name: "idsPartecipanti",
  });

  const idsPartecipanti = getValues("idsPartecipanti");
  const tipologia_UsoId = getValues("tipologia_UsoId");

  const ricalcolaCosti = useCallback(() => {
    let costoSociTemp: number = 0.0;
    idsPartecipanti?.forEach((socio) => {
      const membro = membri?.cards.find((m) => m.id === socio.idPartecipante);
      if (membro && !membro.nonPaga)
        Object.values(slotTariffe).forEach((slot) => {
          const costoTariffa = costi?.tariffe.find(
            (c) =>
              c.tariffe_DefinizioniId === slot.tariffa?.id &&
              c.tipologia_UsoId === tipologia_UsoId &&
              c.tipologia_AssociazioniId === membro.Tipologia_AssociazioniId
          );
          if (costoTariffa) {
            costoSociTemp += +costoTariffa.costoPerSlot;
          }
        });
    });
    setCostoSoci(costoSociTemp);
  }, [costi?.tariffe, membri?.cards, slotTariffe, idsPartecipanti, tipologia_UsoId]);

  useEffect(() => {
    ricalcolaCosti();
  }, [
    fields,
    costi?.tariffe,
    getValues,
    membri?.cards,
    slotTariffe,
    idsPartecipanti,
    tipologia_UsoId,
    ricalcolaCosti,
  ]);

  useEffect(() => {
    Object.values(slotTariffe).forEach((t) => {
      if (t.tariffa?.luciStatus) setLuceIncluso(true);
      if (t.tariffa?.riscaldamentoStatus) setRiscaldamentoIncluso(true);
    });
  }, [slotTariffe]);

  const inizioSplit = orario.oraInizio.split(":");
  const fineSplit = orario.oraFine.split(":");

  const ricalcolaLuci = () => {
    if (!risorsaInfo || !getValues("luci")) setCostoLuci(0);
    else {
      if (risorsaInfo.risorseInfo[0].luciForfait)
        setCostoLuci(getNumber(risorsaInfo.risorseInfo[0].costoLuci));
      else {
        setCostoLuci(
          getNumber(risorsaInfo.risorseInfo[0].costoLuci) * Object.keys(slotTariffe).length
        );
      }
    }
  };
  const ricalcolaRiscaldamento = () => {
    if (!risorsaInfo || !getValues("riscaldamento")) setCostoRiscaldamento(0);
    else {
      if (risorsaInfo.risorseInfo[0].costoRiscaldamentoForfait)
        setCostoRiscaldamento(getNumber(risorsaInfo.risorseInfo[0].costoRiscaldamento));
      else {
        setCostoRiscaldamento(
          getNumber(risorsaInfo.risorseInfo[0].costoRiscaldamento) * Object.keys(slotTariffe).length
        );
      }
    }
  };

  const now = new Date();
  const dataInizio = new Date(giorno);

  dataInizio.setHours(parseInt(inizioSplit[0]));
  dataInizio.setMinutes(parseInt(inizioSplit[1]));

  const aggiungiPartecipanti = useCallback(() => {
    const idTipologia = getValues("tipologia_UsoId");
    const tip = tipologieData?.tipologieUso.find((t) => t.id === idTipologia);
    if (tip === undefined) return;
    const min2 = tip.minPartecipanti === null ? 1 : tip.minPartecipanti;
    const max2 = tip.maxPartecipanti === null ? 1 : tip.maxPartecipanti;
    setMin(min2);
    setMax(max2);
    let num = fields.length;

    if (num < min2)
      while (num < min2) {
        append({ idPartecipante: "" });
        num++;
      }
    else
      while (num >= max2) {
        remove(num);
        num--;
      }
  }, [append, fields.length, getValues, remove, tipologieData?.tipologieUso]);

  const setPartecipante = useCallback(
    (newValue: CardsData | null) => {
      if (
        newValue !== null &&
        !IsSelectable(newValue, giorno, club?.club.certificatoObbligatorio ?? false)
      )
        return;

      setValue("membersId", newValue?.id ?? null);
      if (newValue === null || costi === undefined) {
        setValue("tipologia_UsoId", "");
        setTipologie([]);
        return;
      }
      let tipologieDisp: Tipologia_Uso[] = [];

      Object.values(slotTariffe).forEach((t) => {
        costi.tariffe.forEach((c) => {
          if (
            t.tariffa &&
            c.tipologia_AssociazioniId === newValue.Tipologia_AssociazioniId &&
            c.tariffe_DefinizioniId === t.tariffa.id
          ) {
            const tipUso = tipologieData?.tipologieUso.find((tip) => tip.id === c.tipologia_UsoId);
            if (tipUso && !tipologieDisp.some((tip2) => tip2 === tipUso))
              tipologieDisp.push(tipUso);
          }
        });
      });

      if (tipologieDisp.length > 0) setValue("tipologia_UsoId", tipologieDisp[0].id);

      setTipologie(tipologieDisp);

      if (!tipologieDisp.some((t) => t.id === getValues("tipologia_UsoId")))
        setValue("tipologia_UsoId", "");

      aggiungiPartecipanti();
    },
    [
      aggiungiPartecipanti,
      costi,
      getValues,
      giorno,
      setValue,
      slotTariffe,
      tipologieData?.tipologieUso,
      club?.club.certificatoObbligatorio,
    ]
  );

  const prenotanteOnChange = (event: any, newValue: CardsData | null) => {
    if (
      newValue !== null &&
      !IsSelectable(newValue, giorno, club?.club.certificatoObbligatorio ?? false)
    )
      return;
    setPartecipante(newValue);
  };

  useEffect(() => {
    const id = card?.cards[0].id;

    const partecipante1 = getValues(`idsPartecipanti.0.idPartecipante`);

    if (
      id &&
      role === "USER" &&
      tipologieData?.tipologieUso !== undefined &&
      (partecipante1 === undefined || partecipante1 === "")
    ) {
      const cardData = membri?.cards.find((c) => c.id === id);
      if (cardData) {
        setPartecipante(cardData);
        setValue(`idsPartecipanti.0.idPartecipante`, cardData?.id ?? "");
      }
    }
  }, [
    card?.cards,
    membri?.cards,
    role,
    setPartecipante,
    setValue,
    getValues,
    tipologieData?.tipologieUso,
  ]);

  if (inizioSplit.length !== 2) return <Alert severity="error">Dati non validi!</Alert>;

  if (risorsa === undefined || orario.oraInizio === "" || orario.oraFine === "")
    return <Alert severity="error">Dati non validi!</Alert>;

  if (
    isLoading ||
    isLoading2 ||
    isLoading3 ||
    isLoading4 ||
    isLoading5 ||
    isLoading6 ||
    loadingClub
  )
    return <Loading />;
  if (!membri?.cards) return <Loading />;

  const setTipologia = (e: any) => {
    setValue("tipologia_UsoId", parseInt("" + e.target.value));
    aggiungiPartecipanti();
    const pagante = getValues("membersId");
    const idPartecipante = pagante === null ? "" : pagante;

    update(0, { idPartecipante });
    ricalcolaCosti();
  };

  const onSubmit = (data: Inputs) => {
    setModConferma(true);
  };
  const onSubmit2 = (data: Inputs) => {
    if (data.membersId === null) {
      return;
    }

    const dataIn = new Date(giorno);
    dataIn.setHours(parseInt(inizioSplit[0]));
    dataIn.setMinutes(parseInt(inizioSplit[1]));

    let dataFin = new Date(giorno);
    dataFin.setHours(parseInt(fineSplit[0]));
    dataFin.setMinutes(parseInt(fineSplit[1]));

    if (dataFin < dataIn) dataFin.setDate(dataFin.getDate() + 1);

    const data2 = {
      cifraAddebitata: 0 + +costoSoci + +costoLuci + +costoRiscaldamento,
      dataInizioPrenotazione: dataIn,
      dataFinePrenotazione: dataFin,
      idsPartecipanti: data.idsPartecipanti.map((p) => ({ idPartecipante: 0 + +p.idPartecipante })),
      luci: !!data.luci,
      membersId: data.membersId,
      riscaldamento: !!data.riscaldamento,
      risorseId: risorsaId,
      tariffaId: Object.values(slotTariffe)[0].tariffa?.id ?? -1,
      tipologia_UsoId: 0 + +tipologia_UsoId,
      totalePerGiocatori: +costoSoci,
      totalePerFacilities: 0 + +costoLuci + +costoRiscaldamento,
      slotPrenotati: Object.values(slotTariffe).length,
      risorsaInfoId: risorsaInfo?.risorseInfo[0]?.id ?? -1,
      slots: Object.values(slotTariffe).map((s) => {
        return { idTariffa: s.tariffa?.id ?? -1 };
      }),
      note: data.note,
    };
    changeDatesToUTC(data2);
    prenota(data2);
  };

  const membro = getValues("membersId");
  const tipo = getValues("tipologia_UsoId");
  const listaMembri = membro && membro !== null && tipo && tipo !== "";

  const slotTariffeValues = Object.values(slotTariffe);

  const sintesi = (
    <>
      <Typography variant="caption" component="span">
        Prenotazione per il giorno{" "}
      </Typography>
      <Typography component="span">{format(giorno, "dd/MM/yyyy")}</Typography>
      <br />
      <Typography variant="caption" component="span">
        Dalle{" "}
      </Typography>
      <Typography component="span">{orario.oraInizio} </Typography>
      <Typography variant="caption" component="span">
        alle{" "}
      </Typography>
      <Typography component="span">{orario.oraFine} </Typography>
      <br />
      <Typography variant="caption" component="span">
        Impianto:{" "}
      </Typography>
      <Typography component="span">{risorsa.denominazione}</Typography>
    </>
  );

  const tabellaCosti = (
    <Table size="small" sx={{ width: "auto" }}>
      <TableBody>
        <TableRow>
          <TableCell>Totale Soci</TableCell>
          <TableCell align="right" sx={{ minWidth: "8em" }}>
            {EuroFormatter.format(costoSoci)}
          </TableCell>
        </TableRow>
        <TableRow>
          <TableCell>Totale Luci</TableCell>
          <TableCell align="right" sx={{ minWidth: "8em" }}>
            {EuroFormatter.format(costoLuci)}
          </TableCell>
        </TableRow>
        <TableRow>
          <TableCell>Totale Riscaldamento</TableCell>
          <TableCell align="right" sx={{ minWidth: "8em" }}>
            {EuroFormatter.format(costoRiscaldamento)}
          </TableCell>
        </TableRow>
        <TableRow>
          <TableCell sx={{ fontWeight: "600" }}>Totale</TableCell>
          <TableCell align="right" sx={{ minWidth: "8em", fontWeight: "600" }}>
            {EuroFormatter.format(0 + +costoSoci + +costoLuci + +costoRiscaldamento)}
          </TableCell>
        </TableRow>
      </TableBody>
    </Table>
  );

  if (!modConferma)
    return (
      <Stack gap={2}>
        {dataInizio < now && (
          <Alert severity="warning">
            Attenzione, almeno l'inizio della prenotazione risulta trascorso, potete comunque
            procedere
          </Alert>
        )}

        <Box>{sintesi}</Box>

        <form onSubmit={handleSubmit(onSubmit)}>
          <Grid container columnSpacing={1}>
            <Grid item xs={12} md={6}>
              <Controller
                name="membersId"
                control={control}
                render={({ field }) => (
                  <Autocomplete
                    disabled={role === "USER"}
                    getOptionLabel={(option) =>
                      option.nome + " " + option.cognome + " " + option.codice
                    }
                    options={membri?.cards}
                    value={membri.cards.find((c) => c.id === field.value) || null}
                    onChange={prenotanteOnChange}
                    getOptionDisabled={(opt: CardsData) =>
                      !IsSelectable(opt, giorno, club?.club.certificatoObbligatorio ?? false)
                    }
                    renderOption={(props, option) => (
                      <Box component="li" {...props}>
                        <RigaSocio option={option} giorno={giorno} />
                      </Box>
                    )}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        {...field}
                        required
                        label="Socio Prenotante"
                        variant="standard"
                        error={Boolean(errors.membersId)}
                        helperText={errors.membersId?.message ?? " "}
                      />
                    )}
                  />
                )}
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <Controller
                name="tipologia_UsoId"
                control={control}
                render={({ field }) => (
                  <FormControl {...field} required fullWidth variant="standard">
                    <InputLabel>Tipo Partita</InputLabel>
                    <Select
                      label="Tipologia"
                      value={field.value === undefined ? "" : field.value}
                      onChange={setTipologia}
                    >
                      {tipologie.map((tip) => (
                        <MenuItem key={tip.id} value={tip.id}>
                          {tip.descrizioneUso}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                )}
              />
            </Grid>

            {listaMembri && (
              <Grid item xs={12}>
                {min === max && (
                  <Typography component="span" variant="caption">
                    Partecipanti: {min}
                  </Typography>
                )}

                {min !== max && (
                  <Typography component="span" variant="caption">
                    Partecipanti: min {min} - max {max}
                  </Typography>
                )}
              </Grid>
            )}

            {listaMembri &&
              fields.map((field, index) => (
                <Grid key={field.id} item xs={12} sx={{ mb: 1 }}>
                  <Stack direction="row" alignItems="flex-end" spacing={1}>
                    <Controller
                      name={`idsPartecipanti.${index}.idPartecipante`}
                      control={control}
                      render={({ field }) => (
                        <Autocomplete
                          sx={{ width: ["100%", "100%", "75%", "60%"] }}
                          getOptionLabel={(option) => option.nome + " " + option.cognome}
                          options={membri?.cards.filter((card) => {
                            if (!costi) return false;

                            for (let i = 0; i < idsPartecipanti.length; i++)
                              if (index !== i && idsPartecipanti[i].idPartecipante === card.id)
                                return false;

                            if (
                              !IsSelectable(
                                card,
                                giorno,
                                club?.club.certificatoObbligatorio ?? false
                              )
                            )
                              return false;
                            const tipologiaUso = getValues("tipologia_UsoId");

                            let ok = true;
                            slotTariffeValues.forEach((t) => {
                              ok =
                                ok &&
                                costi.tariffe.some(
                                  (c) =>
                                    t.tariffa &&
                                    c.tipologia_UsoId === tipologiaUso &&
                                    c.tariffe_DefinizioniId === t.tariffa.id &&
                                    c.tipologia_AssociazioniId === card.Tipologia_AssociazioniId &&
                                    c.costoPerSlot !== null
                                );
                            });

                            return ok;
                          })}
                          value={membri.cards.find((c) => c.id === field.value) || null}
                          onChange={(event: any, newValue: CardsData | null) => {
                            setValue(`idsPartecipanti.${index}.idPartecipante`, newValue?.id ?? "");
                            ricalcolaCosti();
                          }}
                          renderOption={(props, option) => (
                            <li className="RigaSocio_Li" {...props}>
                              <RigaSocio
                                option={option}
                                giorno={giorno}
                                certificatoObbligatorio={club?.club.certificatoObbligatorio}
                              />
                            </li>
                          )}
                          renderInput={(params) => (
                            <TextField
                              {...field}
                              {...params}
                              fullWidth
                              required
                              label={"Partecipante " + (index + 1)}
                              variant="standard"
                              error={Boolean(errors?.idsPartecipanti?.[index])}
                              helperText={
                                errors?.idsPartecipanti?.[index]?.idPartecipante?.message ?? ""
                              }
                            />
                          )}
                        />
                      )}
                    />

                    {index >= min && (
                      <IconButton onClick={() => remove(index)}>
                        <DeleteIcon />
                      </IconButton>
                    )}
                  </Stack>
                </Grid>
              ))}

            {listaMembri && fields.length < max && (
              <Grid item xs={12} sx={{ mt: 1, mb: 1 }}>
                <Button variant="text" sx={{ width: "100%" }} onClick={() => append({ idPartecipante: "" })}>
                  Aggiungi
                </Button>
              </Grid>
            )}
          </Grid>

          <Stack gap={2}>
            {role !== "USER" && (
              <Controller
                name="note"
                control={control}
                render={({ field }) => (
                  <TextField {...field} label="Note" fullWidth variant="standard" />
                )}
              />
            )}

            <div>
              <Typography>
                {!risorsa.dispoLuci && "La risorsa non dispone di illuminazione"}
                {risorsa.dispoLuci &&
                  luceIncluso &&
                  "Non sono previsti ulteriori costi di illuminazione"}
                {risorsa.dispoLuci && !luceIncluso && (
                  <Controller
                    name="luci"
                    control={control}
                    defaultValue={false}
                    render={({ field }) => (
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={field.value}
                            onChange={(v) => {
                              setValue("luci", v.target.checked);
                              ricalcolaLuci();
                            }}
                          />
                        }
                        label="Luci"
                      />
                    )}
                  />
                )}
                <br />
                {!risorsa.dispoRiscaldamento && "La risorsa non dispone di riscaldamento"}
                {risorsa.dispoRiscaldamento &&
                  riscaldamentoIncluso &&
                  "Non sono previsti ulteriori costi di riscaldamento"}
                {risorsa.dispoRiscaldamento && !riscaldamentoIncluso && (
                  <Controller
                    name="riscaldamento"
                    control={control}
                    defaultValue={false}
                    render={({ field }) => (
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={field.value}
                            onChange={(v) => {
                              setValue("riscaldamento", v.target.checked);
                              ricalcolaRiscaldamento();
                            }}
                          />
                        }
                        label="Riscaldamento"
                      />
                    )}
                  />
                )}
              </Typography>
            </div>
            <div>{tabellaCosti}</div>
          </Stack>
          <Stack sx={{ mt: 2 }} gap={1} direction={["column", "row"]}>
            <Button variant="outlined" onClick={cambiaPrenot}>
              Cambia prenotazione
            </Button>
            <Button type="submit" variant="contained">
              Prenota
            </Button>
          </Stack>
        </form>
      </Stack>
    );
  else {
    const prenotante = membri.cards.find((c) => c.id === membro);
    const luci = getValues("luci");
    const riscaldamento = getValues("riscaldamento");
    const tipologia_UsoId = getValues("tipologia_UsoId");
    const note = getValues("note");
    const partecipanti = getValues("idsPartecipanti");
    return (
      <form onSubmit={handleSubmit(onSubmit2)}>
        <Stack gap={1}>
          <ConfermaBox>
            <Typography variant="h6">Sintesi prenotazione</Typography>
            {sintesi}
            <br />
            <Typography variant="caption" component="span">
              Utilizzo:{" "}
            </Typography>
            <Typography component="span">
              {tipologie.find((t) => t.id === tipologia_UsoId)?.descrizioneUso ?? ""}
            </Typography>
          </ConfermaBox>
          <ConfermaBox>
            <Typography variant="h6">Socio Prenotante</Typography>
            <>
              {prenotante &&
                prenotante.codice +
                  " - " +
                  prenotante.cognome +
                  " " +
                  prenotante.cognome +
                  " [" +
                  prenotante.codiceSocio +
                  "]"}
            </>
          </ConfermaBox>
          <ConfermaBox>
            <Typography variant="h6">Informazioni utenti</Typography>
            <Table size="small" sx={{ maxWidth: 800 }}>
              <TableBody>
                {partecipanti !== null &&
                  partecipanti.map((f, index) => {
                    const partecipante = membri.cards.find((c) => c.id === f.idPartecipante);

                    if (!partecipante) return <></>;
                    return (
                      <TableRow key={partecipante.id}>
                        <TableCell>{index}</TableCell>
                        <TableCell>
                          {tipologieAssoc?.tipologie.find(
                            (t) => t.id === partecipante.Tipologia_AssociazioniId
                          )?.denominazione ?? ""}
                        </TableCell>
                        <TableCell>{partecipante.codice}</TableCell>
                        <TableCell>
                          {partecipante.cognome} {partecipante.nome}
                        </TableCell>
                      </TableRow>
                    );
                  })}
              </TableBody>
            </Table>
          </ConfermaBox>
          {note !== null && note !== undefined && note !== "" && (
            <ConfermaBox>
              <Typography variant="h6">Note</Typography>
              <span>{note}</span>
            </ConfermaBox>
          )}
          <ConfermaBox>
            <Typography variant="h6">Informazioni extra</Typography>
            <Typography>
              {!risorsa.dispoLuci && "La risorsa non dispone di illuminazione"}
              {risorsa.dispoLuci &&
                luceIncluso &&
                "Non sono previsti ulteriori costi di illuminazione"}

              {risorsa.dispoLuci && !luceIncluso && luci && <>Servizio illuminazione prenotato</>}
              {risorsa.dispoLuci && !luceIncluso && !luci && (
                <>Servizio illuminazione NON prenotato</>
              )}

              <br />
              {!risorsa.dispoRiscaldamento && "La risorsa non dispone di riscaldamento"}
              {risorsa.dispoRiscaldamento &&
                riscaldamentoIncluso &&
                "Non sono previsti ulteriori costi di riscaldamento"}

              {risorsa.dispoRiscaldamento && !riscaldamentoIncluso && riscaldamento && (
                <>Servizio riscaldamento prenotato</>
              )}
              {risorsa.dispoRiscaldamento && !riscaldamentoIncluso && !riscaldamento && (
                <>Servizio riscaldamento NON prenotato</>
              )}
            </Typography>
          </ConfermaBox>
          <ConfermaBox>
            <Typography variant="h6">Costi</Typography>
            {tabellaCosti}
          </ConfermaBox>
        </Stack>

        <Button
          variant="contained"
          color="secondary"
          sx={{ mt: 2, mr: 2 }}
          onClick={() => setModConferma(false)}
        >
          Modifica dettagli
        </Button>

        <Button variant="contained" sx={{ mt: 2 }} type="submit">
          Conferma Prenotazione
        </Button>
      </form>
    );
  }
}
